<template>
    <v-container fluid class="pa-3">

        <v-row justify="center" align="center" :class="marginRow()" style="">
            <v-col xl="8" lg="8" md="8" sm="12" cols="12" :class="marginCol()">
                <h1>{{$t('ourstory.ourstory')}}</h1>

                <span v-html="$t('ourstory.par1')"></span>
                <span v-html="$t('ourstory.par2')"></span>
                <span v-html="$t('ourstory.par3')"></span>
                <span v-html="$t('ourstory.par4')"></span>

            </v-col>

            <v-col xl="4" lg="4" md="4" sm="12" cols="12" class="ma-0 pa-2" justify="center">
                <v-img
                        src="../assets/Tailoring/tailoring2.jpg"
                        contain
                        width="100%"
                        max-height="350px"
                >
                </v-img>
            </v-col>
        </v-row>

        <v-row justify="center" align="center" :class="marginRow()" style="">
            <v-col xl="8" lg="8" md="8" sm="12" cols="12" :class="marginCol()">
                <h1>{{$t('ourstory.tailoring')}}</h1>

                <span v-html="$t('ourstory.tailor1')"></span>
                <span v-html="$t('ourstory.tailor3')"></span>
                <span v-html="$t('ourstory.tailor4')"></span>
                <span v-html="$t('ourstory.tailor5')"></span>

            </v-col>

            <v-col xl="4" lg="4" md="4" sm="12" cols="12" class="ma-0 pa-2" justify="center">
                <v-img
                        src="../assets/Tailoring/tailoring4.jpg"
                        contain
                        width="100%"
                        max-height="350px"
                >
                </v-img>
            </v-col>
        </v-row>

        <v-row v-if="!isMobile()" justify="center" class="ma-3 mt-10">
            <v-col cols="4" class="ma-0">
                <v-img
                        src="../assets/Tailoring/tailoring1.jpg"
                        contain
                        width="100%"
                        max-height="350px"
                >
                </v-img>
            </v-col>
            <v-col cols="4" class="ma-0">
                <v-img
                        src="../assets/Tailoring/tailoring5.jpg"
                        contain
                        width="100%"
                        max-height="350px"
                >
                </v-img>
            </v-col>
            <v-col cols="4" class="ma-0">
                <v-img
                        src="../assets/Tailoring/tailoring6.jpg"
                        contain
                        width="100%"
                        max-height="350px"
                >
                </v-img>
            </v-col>
        </v-row>

        <v-row v-if="isMobile()" class="mt-10">
            <v-carousel
                    cycle
                    hide-delimiters
                    :show-arrows="false"
                    height="100%"
            >
                <v-carousel-item eager>
                    <v-img
                            src="../assets/Tailoring/tailoring1.jpg"
                            width="100%"
                            eager
                    >
                    </v-img>
                </v-carousel-item>
                <v-carousel-item eager>
                    <v-img
                            src="../assets/Tailoring/tailoring5.jpg"
                            width="100%"
                            eager
                    >
                    </v-img>
                </v-carousel-item>
                <v-carousel-item eager>
                    <v-img
                            src="../assets/Tailoring/tailoring6.jpg"
                            width="100%"
                            eager
                    >
                    </v-img>
                </v-carousel-item>
            </v-carousel>
        </v-row>

    </v-container>
</template>

<script>
    export default {
        name: "ChiSiamo",

        components: {
        },

        methods: {
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            marginRow(){
                if(this.isMobile()){
                    return "ma-0"
                } else {
                    return "ma-3"
                }
            },
            marginCol(){
                if(this.isMobile()){
                    return "ma-0"
                } else {
                    return "ma-0 pl-10"
                }
            }
        }
    }
</script>

<style scoped>

</style>